import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import * as helpers from "../../../../helpers/helpers";
import { PIN_FILTER_KEYS } from "./pins";

export default function FilterSubmitButton({
  className = "",
  clearStep,
  setValue,
  selectedTab = null,
  filterData,
  drawnFeatures
}) {
  const navigate = useNavigate();
  const location = useLocation();
  const handleClear = (e) => {
    e.preventDefault();
    console.log(clearStep, "clearStep in FilterSubmitButton",selectedTab);
    if (clearStep === "property_type") {
        removeKeysFromUrl(['property_type', 'popular_property_type', 'more_property_type']);
      }
      else if (clearStep === "size") {
        removeKeysFromUrl(['min_unites', 'max_unites', 'min_sf', 'max_sf','min_lotsize', 'max_lotsize','building_min_lotsize', 'building_max_lotsize','size_min_lotsize', 'size_max_lotsize']);return;
      }
       else if (clearStep === "my_pins") {
        removeKeysFromUrl(PIN_FILTER_KEYS);
        return;
      }
       else if (clearStep === "my_properties") {
        removeKeysFromUrl([
          "labels_includes_arr",
          "labels_excludes_arr",
          "labels_text",
        ]);
        return; // ✅ Stop execution to avoid second window.location.href overwrite
      } else if (clearStep === "recommended") {
        removeKeysFromUrl([
          "recommend_year_build",
          "year_build",
          "year_build_until",
          "recommend_year_build_until",
          "recommend_properties_in_portfolio_min",
          "recommend_properties_in_portfolio_max",
          "recommend_occupaid",
          "recommended_owner_property_sq_ft",
          "recommended_owner_portfolio",
          "owner_occupaid",
          "occupaid",
        ]);
        return; // ✅ Same here
      }
      
      else if(clearStep==='more_filters' && selectedTab===0){
        removeKeysFromUrl(['property_type', 'popular_property_type', 'more_property_type']);
        return; 
      }
      else if(clearStep==='more_filters' && selectedTab===1){
        removeKeysFromUrl(['recommend_year_build', 'year_build', 'building_lot_year_build','recommend_year_build_until','year_build_until','building_lot_year_build_until','zonedcodelocal','min_lotsize','max_lotsize','building_min_lotsize','building_max_lotsize','size_min_lotsize','size_max_lotsize','building_roofCover']);
        return; 
      }
      else if(clearStep==='more_filters' && selectedTab===2){
        removeKeysFromUrl(['properties_in_portfolio_min','owner_properties_in_portfolio_min','recommend_properties_in_portfolio_min','properties_in_portfolio_max','owner_properties_in_portfolio_max','recommend_properties_in_portfolio_max','portfolio_assessed_value', 'owner_type', 'owner_name','previously_viewed','reported_owner','reported_owner_address','occupaid','owner_occupaid','recommend_occupaid']);
        return; 
      }
      else if(clearStep==='more_filters' && selectedTab===3){
        removeKeysFromUrl(['sale_date_within', 'sale_date', 'min_sales_price', 'max_sales_price','min_sales_price_sf', 'max_sales_price_sf','min_sales_price_acr', 'max_sales_price_acr']);
        return; 
      }
      else if(clearStep==='more_filters' && selectedTab===4){
        removeKeysFromUrl([
          "mortgage_amount",
          "mortage_origination",
          "tax_min_amount",
          "tax_max_amount",
        ]);
        return; 
      }
      else if(clearStep==='more_filters' && selectedTab===5){
        removeKeysFromUrl(['tax_min_year','tax_max_year','min_tax_amount','max_tax_amount']);
        return; 
      }
      else if(clearStep==='more_filters' && selectedTab===6){
        removeKeysFromUrl([
          "labels_includes_arr",
          "labels_excludes_arr",
          "labels_text",
          "viewed_date",
          "notes_text",
          "note",
          ...PIN_FILTER_KEYS,
        ]);
        return;
      }
    };

  const removeKeysFromUrl = (keys) => {
    const searchParams = new URLSearchParams(location.search);

    keys.forEach((key) => {
      searchParams.delete(key); // Remove key from query string
    });

    const geometry_polygon = helpers.getUrlParameter("geometry");
    let geometry = drawnFeatures || geometry_polygon || null;
    const allParams = {};
      for (const [key, value] of searchParams.entries()) {
        allParams[key] = value;
      }
     if (geometry) {
      allParams.geometry = geometry;
      } else {
        searchParams.delete("geometry");
        delete allParams[geometry];

      } 
      const queryString = Object.entries(allParams)
        .filter(([key, value]) => {
          return !(
            value === null ||
            value === undefined ||
            value === false ||
            value === "" ||
            value === "null" ||
            value === "false" ||
            value === "undefined"
          );
        })
        .map(
          ([key, value]) =>
            `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
        )
        .join("&");
        // console.log("queryString:", queryString);return;


        // ✅ Only redirect if necessary
         window.location.href = `${location.pathname}?${queryString}`;
};

  const updateUrlAndReload = () => {
    const queryParams = new URLSearchParams(location.search);

    const allParams = {};
      for (const [key, value] of queryParams.entries()) {
        allParams[key] = value;
      }

    // const frmData = filterData;
    const queryString = Object.entries(allParams)
      .filter(([key, value]) => {
        // Remove if value is null, undefined, false, empty string
        return !(
          value === null ||
          value === undefined ||
          value === false ||
          value === "" ||
          value === "null" ||
          value === "false" ||
          value === "undefined"
        );
      })
      .map(
        ([key, value]) =>
          `${encodeURIComponent(key)}=${encodeURIComponent(value)}`
      )
      .join("&");
  window.location.href = `${location.pathname}?${queryString}`;
    
  };
  return (
    <>
      <div className={`btn_blk text-right ${className}`}>
        <button
          className="site_btn blank yellow_blank"
          type="button"
          onClick={handleClear}
        >
          Clear
        </button>
        <button type="submit" className="site_btn">
          Apply
        </button>
      </div>
    </>
  );
}
